module.exports = __webpack_public_path__ + "static/assets/e771d810e0467436657c918dc23b9b80.gif";